// extracted by mini-css-extract-plugin
module.exports = {"tabs":"_7a3fb80146--tabs--d1EN4","tabs--animated":"_7a3fb80146--tabs--animated--IDnlt"};